import React from 'react';
import { motion } from 'framer-motion';
import { FiPlus } from 'react-icons/fi';

function DashboardBrokerTop({ totalBrokers, onSearch, onStatusClear, onAddBroker }) {
  // const [searchValue, setSearchValue] = useState('');
  // const [isSearchFocused, setIsSearchFocused] = useState(false);

  // const handleClearSearch = () => {
  //   setSearchValue('');
  //   onSearch('');
  // };

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div className="flex items-center space-x-4">
        <h2 className="text-2xl font-semibold text-gray-800">Brokers</h2>
        <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
          {totalBrokers} total
        </span>
      </div>

      <div className="flex items-center space-x-4">
        {/* <motion.div
          className={`relative flex items-center transition-all duration-200 ${
            isSearchFocused ? 'w-64' : 'w-48'
          }`}
          whileHover={{ scale: 1.02 }}
        >
          <div className="absolute left-3 text-gray-400">
            <FiSearch className="w-5 h-5" />
          </div>
          <input
            type="text"
            value={searchValue}
            onChange={handleSearchChange}
            onFocus={() => setIsSearchFocused(true)}
            onBlur={() => setIsSearchFocused(false)}
            placeholder="Search brokers..."
            className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {searchValue && (
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              onClick={handleClearSearch}
              className="absolute right-3 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FiX className="w-4 h-4" />
            </motion.button>
          )}
        </motion.div> */}

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onAddBroker}
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          <FiPlus className="w-5 h-5" />
          <span>Add Broker</span>
        </motion.button>
      </div>
    </div>
  );
}

export default DashboardBrokerTop;
